export class OtherExtendedWarranty {
  contractOwner: string = null;
  dailyRentalAllowance: number = null;
  deductibleAmount: number = null;
  effectiveDate: Date = null;
  effectiveMileage: number = null;
  expiryDate: Date = null;
  expiryMileage: number = null;
  planDescription: string = null;
  policyNumber: string = null;
  towingLimit: number = null;
  vehicleId: number = null;
  warrantyCompanyId: string = null;
  warrantyClassName: string = null;

  constructor(obj?: OtherExtendedWarranty) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
